<p-panel
  [toggleable]="isCardToggleable"
  [collapsed]="data.collapsed"
  (collapsedChange)="panelToggled($event)"
  collapseIcon="pi pi-fw pi-chevron-up"
  expandIcon="pi pi-fw pi-chevron-down"
  toggler="header"
>
  <ng-template
    *ngIf="isCardToggleable"
    pTemplate="header"
    class="panelCardStyle"
  >
    <ng-container
      [ngTemplateOutlet]="templateHeader.first"
      [ngTemplateOutletContext]="{ dataVar: data }"
    ></ng-container>
  </ng-template>
  <ng-container
    [ngTemplateOutlet]="templateHeader.last"
    [ngTemplateOutletContext]="{ dataVar: data }"
  ></ng-container>
</p-panel>
